import { useState } from "react";
import NoRecord from "../../form/NoRecord";
import { curSym } from "../../../utils/pip";
import { useDispatch, useSelector } from "react-redux";
import ReactPagination from "../../table/ReactPagination";
import PaginationDropdown from "../../table/PaginationDropdown";
import InviteFreelancer from "../../Modals/common/project/InviteFreelancer";
import { setIsInvite } from "../../../redux/features/hire-talent/reducers/projectReducer";
import {
  fetchMyProjects,
  fetchRecommendedFreelancer,
  sendInvitationToFreelancer,
} from "../../../redux/features/hire-talent/actions/projectAction";

const RecommendedFreelancer = ({ selectProject, setSelectProject }) => {
  const dispatch = useDispatch();

  const { recomFreelancerList, isInvite, projectList } = useSelector(
    (state) => state?.hireTalent?.project
  );
  const [currentPage, setCurrentPage] = useState(0);
  const [listPerPages, setListPerPages] = useState(5);
  // const [freelancer_id, setFreelancer_id] = useState(null);
  const paginatedList = recomFreelancerList?.slice(
    currentPage * listPerPages,
    (currentPage + 1) * listPerPages
  );

  const handlePageClick = (data) => {
    setCurrentPage(data?.selected);
  };

  const handleInvite = (freelancer_id) => {
    const callback = (res) => {
      if (res?.success) {
        setSelectProject('')
        dispatch(fetchMyProjects());
        dispatch(fetchRecommendedFreelancer());
        dispatch(setIsInvite(false));
      }
    };
    dispatch(
      sendInvitationToFreelancer({
        payload: { project_id: selectProject, freelancer_id },
        callback,
      })
    );
  };

  return (
    <div className="row ct_mt_16 gx-md-3">
      <div className="col-md-12">
        <h2 className="ct_fs_20 ct_darkblue_text ct_mb_30">
          Recommended Freelancers For Your Project
        </h2>
      </div>
      {paginatedList?.length > 0 && (
        <>
          {paginatedList?.map((item, index) => (
            <div className="col-lg-4 col-md-6  ct_mb_16">
              <div className="ct_outline_bg ct_py_20_px_30">
                <div className="ct_profile_header">
                  <div className="ct_avatar">
                    <img
                      src={
                        item?.profile_image || "/assets/img/user_profile.png"
                      }
                      alt="User"
                    />
                  </div>

                  <div className="ct_user_info">
                    <h4>
                      {`${item?.first_name} ${item?.last_name}`}
                      <span className="ct_verified">
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M10.2789 3.75843C10.1869 3.61152 10.0515 3.49693 9.89135 3.43061C9.73123 3.3643 9.55442 3.34955 9.38553 3.38843L8.18686 3.66376C8.06402 3.69199 7.93637 3.69199 7.81353 3.66376L6.61486 3.38843C6.44597 3.34955 6.26917 3.3643 6.10905 3.43061C5.94893 3.49693 5.81347 3.61152 5.72153 3.75843L5.0682 4.80109C5.00153 4.90776 4.91153 4.99776 4.80486 5.06509L3.7622 5.71843C3.61554 5.81029 3.50112 5.94552 3.43482 6.10537C3.36852 6.26521 3.35362 6.44173 3.3922 6.61043L3.66753 7.81043C3.69566 7.93305 3.69566 8.06046 3.66753 8.18309L3.3922 9.38243C3.35347 9.55122 3.36829 9.72788 3.4346 9.88786C3.50091 10.0478 3.61542 10.1832 3.7622 10.2751L4.80486 10.9284C4.91153 10.9951 5.00153 11.0851 5.06886 11.1918L5.7222 12.2344C5.9102 12.5351 6.26886 12.6838 6.61486 12.6044L7.81353 12.3291C7.93637 12.3009 8.06402 12.3009 8.18686 12.3291L9.3862 12.6044C9.55499 12.6432 9.73166 12.6283 9.89164 12.562C10.0516 12.4957 10.187 12.3812 10.2789 12.2344L10.9322 11.1918C10.9989 11.0851 11.0889 10.9951 11.1955 10.9284L12.2389 10.2751C12.3857 10.1831 12.5001 10.0476 12.5663 9.88745C12.6325 9.72734 12.6471 9.55058 12.6082 9.38176L12.3335 8.18309C12.3053 8.06025 12.3053 7.9326 12.3335 7.80976L12.6089 6.61043C12.6477 6.4417 12.6329 6.26509 12.5667 6.10511C12.5006 5.94514 12.3862 5.80975 12.2395 5.71776L11.1962 5.06443C11.0897 4.99764 10.9997 4.90761 10.9329 4.80109L10.2789 3.75843ZM9.94353 6.50976C9.98477 6.43394 9.99498 6.34508 9.97203 6.26187C9.94908 6.17867 9.89475 6.10762 9.82048 6.06365C9.7462 6.01969 9.65777 6.00626 9.57379 6.02617C9.48981 6.04608 9.41683 6.0978 9.3702 6.17043L7.62686 9.12109L6.5742 8.11309C6.54297 8.08103 6.5056 8.05558 6.46433 8.03827C6.42305 8.02096 6.37871 8.01213 6.33395 8.01233C6.28919 8.01252 6.24493 8.02173 6.2038 8.0394C6.16268 8.05707 6.12553 8.08285 6.09459 8.11518C6.06364 8.14752 6.03952 8.18576 6.02367 8.22762C6.00782 8.26948 6.00056 8.3141 6.00233 8.35883C6.0041 8.40355 6.01485 8.44746 6.03396 8.48794C6.05306 8.52842 6.08013 8.56463 6.11353 8.59443L7.46953 9.89376C7.50582 9.92846 7.54949 9.95452 7.59726 9.96998C7.64504 9.98544 7.69568 9.98991 7.74543 9.98305C7.79517 9.97619 7.84272 9.95818 7.88453 9.93037C7.92633 9.90255 7.96132 9.86565 7.98686 9.82243L9.94353 6.50976Z"
                            fill="#FFB703"
                          />
                        </svg>
                      </span>
                    </h4>
                    <p className="ct_role">{item?.talent_role || ""}</p>
                    <div className="ct_rating">
                      <svg
                        width="15"
                        height="15"
                        viewBox="0 0 10 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5.00063 7.20052L3.27146 8.24219C3.19507 8.2908 3.11521 8.31163 3.03188 8.30469C2.94854 8.29774 2.87563 8.26997 2.81313 8.22135C2.75063 8.17274 2.70201 8.11205 2.66729 8.03927C2.63257 7.96649 2.62563 7.88483 2.64646 7.79427L3.10479 5.82552L1.57354 4.5026C1.5041 4.4401 1.46076 4.36885 1.44354 4.28885C1.42632 4.20885 1.43146 4.1308 1.45896 4.05469C1.48646 3.97858 1.52813 3.91608 1.58396 3.86719C1.63979 3.8183 1.71618 3.78705 1.81313 3.77344L3.83396 3.59635L4.61521 1.74219C4.64993 1.65885 4.70382 1.59635 4.77688 1.55469C4.84993 1.51302 4.92451 1.49219 5.00063 1.49219C5.07674 1.49219 5.15132 1.51302 5.22438 1.55469C5.29743 1.59635 5.35132 1.65885 5.38604 1.74219L6.16729 3.59635L8.18812 3.77344C8.28535 3.78733 8.36174 3.81858 8.41729 3.86719C8.47285 3.9158 8.51451 3.9783 8.54229 4.05469C8.57007 4.13108 8.57535 4.20927 8.55813 4.28927C8.5409 4.36927 8.49743 4.44038 8.42771 4.5026L6.89646 5.82552L7.35479 7.79427C7.37563 7.88455 7.36868 7.96622 7.33396 8.03927C7.29924 8.11233 7.25063 8.17302 7.18813 8.22135C7.12563 8.26969 7.05271 8.29746 6.96938 8.30469C6.88604 8.31191 6.80618 8.29108 6.72979 8.24219L5.00063 7.20052Z"
                          fill="#FFB703"
                        />
                      </svg>
                      4.3 <span>(15 Reviews)</span>
                    </div>
                  </div>
                </div>
                <div className="ct_info_boxes ct_mt_20">
                  <div className="ct_info_box">
                    <h6>{item?.location || ""}</h6>
                    <p>2500 Miles Away</p>
                  </div>
                  <div className="ct_info_box">
                    <h6>
                      {curSym}
                      {item?.salary_preference || ""}
                    </h6>
                    <p>Average Daily Rate</p>
                  </div>
                </div>
                <div className="ct_actions">
                  <button className="ct_yellow_btn ct_outline_light_grey px-3 ct_h_35 ct_border_radius_10 d-flex align-items-center gap-2 w-100">
                    <i className="fa-regular fa-heart"></i> Wishlist
                  </button>
                  <button
                    className="ct_yellow_btn ct_outline_light_grey px-3 ct_h_35 ct_border_radius_10  d-flex align-items-center gap-2 w-100"
                    type="button"
                    style={{ color: "#FFCC00" }}
                    disabled={item?.is_invited}
                    onClick={() => {
                      // setFreelancer_id(item?.user_id);
                      handleInvite(item?.user_id);
                    }}
                  >
                    {item?.is_invited ? (
                      "Invited"
                    ) : (
                      <>
                        <i className="fa-solid fa-plus"></i>
                        Invite
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          ))}
        </>
      )}
      {paginatedList?.length == 0 && <NoRecord />}

      {paginatedList?.length > 0 && (
        <div className="d-flex justify-content-between align-items-center mt-4 ">
          <div>
            <PaginationDropdown
              onChange={(val) => {
                setListPerPages(val);
                setCurrentPage(0);
              }}
            />
          </div>
          <div>
            <ReactPagination
              pageCount={Math.ceil(recomFreelancerList?.length / listPerPages)}
              onPageChange={handlePageClick}
              currentPage={currentPage}
            />
          </div>
        </div>
      )}

      {isInvite && (
        <InviteFreelancer
          projectList={projectList?.all}
          onClose={() => dispatch(setIsInvite(false))}
          handleInvite={(data) => handleInvite(data)}
        />
      )}
    </div>
  );
};

export default RecommendedFreelancer;

